import React from 'react'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'

const Desktop = ({ children }) => {
  return <MediaQuery minWidth={992}>{children}</MediaQuery>
}

const Tablet = ({ children }) => {
  return (
    <MediaQuery minWidth={768} maxWidth={991}>
      {children}
    </MediaQuery>
  )
}

const Mobile = ({ children }) => {
  return <MediaQuery maxWidth={767}>{children}</MediaQuery>
}

const ScreenPropTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

Desktop.propTypes = ScreenPropTypes
Tablet.propTypes = ScreenPropTypes
Mobile.propTypes = ScreenPropTypes

export const Responsive = {
  Desktop,
  Tablet,
  Mobile,
}
